'use client';

import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import CircularLearningProgress from '@classify/react-product-components/CircularLearningProgress';
import Stack from '@classify/react-core-components/Stack';
import { translate } from '@openclassrooms/translations';
type Props = {
  progression: number;
};
export default function CourseProgress(t0) {
  const $ = _c(8);
  const {
    progression
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography component="span" variant="overline" sx={{
      mb: 1,
      display: "inline-block"
    }}>{translate("course.header.progress.label")}</Typography>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = progression - 1;
  let t3;
  if ($[1] !== t2) {
    t3 = <CircularLearningProgress value={t2} maxValue={100} />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== progression) {
    t4 = <Typography variant="h3" component="span">{progression}%</Typography>;
    $[3] = progression;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <>{t1}<Stack direction="row" alignItems="center" gap={1}>{t3}{t4}</Stack></>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}